import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

import { StorageServiceService } from '../../../shared/services/storage-service.service';
import { AuthAnswer } from '../../models/auth-answer';

/**
 * Service for handling tokens storage and validation
 */
@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(
    private readonly storageService: StorageServiceService,
    private jwtHelper: JwtHelperService
  ) {}

  public saveData(auth: AuthAnswer): void {
    this.storageService.storage.clear();
    this.storageService.storage.setItem('token', auth.accessToken);
    this.storageService.storage.setItem('refreshToken', auth.refreshToken);
  }

  public getToken(): string | null {
    return this.storageService.storage.getItem('token');
  }

  public getRefreshToken(): string | null {
    return this.storageService.storage.getItem('refreshToken');
  }

  public isAccessTokenValid(): boolean {
    const token = this.getToken();
    return this.validateToken(token);
  }

  public isRefreshTokenValid(): boolean {
    const token = this.getRefreshToken();
    return this.validateToken(token);
  }

  validateToken(token: string | null | undefined): boolean {
    return token ? !this.jwtHelper.isTokenExpired(token) : false;
  }
}
